import React from "react";
import { useMeasure } from "react-use";

import { cx } from "~/tools/class-variance";

import { calculateGridLayout } from "../charts-grid/calculate-grid-layout";
import { Pagination } from "../pagination";
import { useTimeSeriesPages } from "../pagination/use-time-series-pages";

import { StatGrid, type StatGridProps } from "./_stat-grid";

interface PaginatedStatChartWidgetProps extends Omit<StatGridProps, "className" | "height" | "width" | "onShowAll"> {
	className?: string;
}

export const PaginatedStatChartWidget = React.memo<PaginatedStatChartWidgetProps>(
	({ className, timeSeries, minCellSize, ...props }) => {
		const [measureRef, { width, height }] = useMeasure<HTMLDivElement>();

		const { cols, rows } = calculateGridLayout({ width, height, minCellSize, count: timeSeries.length });
		const [allPages, pageIndex, setPageIndex] = useTimeSeriesPages(cols * rows, timeSeries);

		return (
			<div className={cx("flex flex-col gap-4", className)}>
				{allPages.length > 1 && <Pagination index={pageIndex} onIndexChange={setPageIndex} pages={allPages} />}

				<StatGrid
					{...props}
					className="min-h-0 flex-1"
					height={height}
					minCellSize={minCellSize}
					ref={measureRef}
					timeSeries={allPages.at(pageIndex) ?? []}
					width={width}
				/>
			</div>
		);
	},
);
